// Models that match the actual API response structure

export interface CampaignApiResponseDto {
  count: number;
  data: CampaignApiDto[];
  total: number;
}

export interface CampaignApiDto {
  campaignNumber: string;
  name: string;
  description?: string;
  type: CampaignApiType;
  audienceType: CampaignAudienceType;
  couponTemplateNumber?: string;
  couponName?: string;
  couponType?: string;
  executionTime?: string; // for ONE_TIME campaigns
  eventType?: CampaignEventType; // for RECURRING campaigns
  offsetDays?: number; // for RECURRING campaigns
  executionHour?: string; // for RECURRING campaigns
  startDate: string;
  endDate?: string;
  validityDays?: number;
  oneTimeValidityType?: "DAYS_AFTER_PURCHASE" | "FIXED_EXPIRY_DATE";
  fixedExpiryDate?: string;
  couponValidityType?: string;
  notificationPlan: CampaignNotificationPlan;
  targets: string[];
  reminders?: CampaignReminderDto[];
  // Computed fields for frontend
  status?: CampaignApiStatus;
  createdAt?: string;
  updatedAt?: string;
  createdBy?: string;
  statistics?: CampaignApiStatisticsDto;
}

export enum CampaignApiType {
  RECURRING = 'RECURRING',
  ONE_TIME = 'ONE_TIME'
}

export enum CampaignApiStatus {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE', 
  SCHEDULED = 'SCHEDULED',
  PAUSED = 'PAUSED',
  ENDED = 'ENDED',
  CANCELLED = 'CANCELLED'
}

export enum CampaignAudienceType {
  ALL = 'ALL',
  CIRCLE = 'CIRCLE',
  SEGMENT = 'SEGMENT'
}

export enum CampaignEventType {
  BIRTHDAY = 'BIRTHDAY',
  CIRCLE_UPGRADE = 'CIRCLE_UPGRADE',
  EMAIL_OPT_IN = 'EMAIL_OPT_IN',
  REGISTRATION = 'REGISTRATION'
}

export enum CampaignNotificationPlan {
  EMAIL = 'EMAIL',
  PUSH = 'PUSH',
  BOTH = 'BOTH'
}

export interface CampaignReminderDto {
  id: number;
  channel: string;
  executionHour: string;
  offsetDays: number;
}

export interface CampaignApiStatisticsDto {
  totalReach: number;
  totalSent: number;
  totalDelivered: number;
  totalOpened: number;
  totalClicked: number;
  totalRedemptions: number;
  conversionRate: number;
  revenue: number;
  currency: string;
  lastUpdated: string;
}

// Search and pagination request
export interface CampaignApiSearchRequestDto {
  page?: number;        // Backend uses 'page' not 'pageNumber'
  size?: number;        // Backend uses 'size' not 'pageSize' 
  sortBy?: string;
  sortDirection?: 'asc' | 'desc';  // Backend uses lowercase
  types?: string[];     // Backend uses 'types' plural
  status?: string[];
  name?: string;
  startDateFrom?: string;
  startDateTo?: string;
  endDateFrom?: string;
  endDateTo?: string;
}

// Create campaign request
export interface CreateCampaignApiRequestDto {
  name: string;
  description?: string;
  type: CampaignApiType;
  audienceType: CampaignAudienceType;
  eventType?: CampaignEventType;
  startDate: string;
  endDate?: string;
  executionTime?: string;
  executionHour?: string;
  offsetDays?: number;
  notificationPlan: CampaignNotificationPlan;
  couponTemplateNumber?: string;
  targets: string[];
  reminders?: Omit<CampaignReminderDto, 'id'>[];
}
